import { createContext } from 'react';

const ResourcesContext = createContext();

export default ResourcesContext;
